import { BehaviorSubject, Subject } from 'rxjs';
import { filter } from 'rxjs/operators';
import * as i0 from "@angular/core";
export class BimElementStore {
    constructor() {
        this.currentElementInfo$ = new BehaviorSubject({});
        this.currentElement$ = new BehaviorSubject(null);
        this.refreshCurrentElement$ = new Subject();
        this.refreshOuvrages$ = new Subject();
        this.refreshElementDetail$ = new Subject();
        this.refreshFavoriteColumns$ = new Subject();
        this.refreshPersonnes$ = new Subject();
        this.loadingState = new BehaviorSubject(false);
    }
    setCurrentElementInfo(id, typeElement) {
        this.currentElementInfo$.next({ id, typeElement });
    }
    unsetCurrentElementInfo() {
        this.currentElementInfo$.next({});
    }
    getCurrentElementInfo() {
        return this.currentElementInfo$.asObservable().pipe(filter(el => el.id != null && el.typeElement != null));
    }
    getCurrentElementInfoSnapshot() {
        return this.currentElementInfo$.getValue();
    }
    setCurrentElement(element) {
        this.currentElement$.next(element);
    }
    unsetCurrentElement() {
        this.currentElement$.next(null);
    }
    getCurrentElement() {
        return this.currentElement$.asObservable().pipe(filter(el => el !== null));
    }
    getCurrentElementSnapshot() {
        return this.currentElement$.getValue();
    }
    setLoadingState(value) {
        this.loadingState.next(value);
    }
    getLoadingState() {
        return this.loadingState.asObservable();
    }
    /**
     * Demande le rafraîchissement de l'élément courant.
     */
    refreshCurrentElement() {
        this.refreshCurrentElement$.next(true);
    }
    /**
     * Indique chaque fois qu'un rafraîchissement de l'élément courant est demandé.
     */
    getCurrentElementRefresh() {
        return this.refreshCurrentElement$.asObservable();
    }
    /**
     * Demande le rafraîchissement des ouvrages.
     */
    refreshOuvrages() {
        this.refreshOuvrages$.next(true);
    }
    /**
     * Indique chaque fois qu'un rafraîchissement des ouvrages est demandé.
     */
    getOuvragesRefresh() {
        return this.refreshOuvrages$.asObservable();
    }
    /**
     * Demande le rafraîchissement de l'élément dont le détail est visualisé.
     */
    refreshElementDetail() {
        this.refreshElementDetail$.next(true);
    }
    /**
     * Indique chaque fois qu'un rafraîchissement de l'élément dont le détail est visualisé est demandé.
     */
    getElementDetailRefresh() {
        return this.refreshElementDetail$.pipe(filter(it => it != null));
    }
    /**
     * Demande le rafraîchissement des colonnes affichées dans le tableau.
     */
    refreshFavoriteColumns() {
        this.refreshFavoriteColumns$.next(true);
    }
    /**
     * Indique chaque fois qu'un rafraîchissement des colonnes affichées dans le tableau est demandé.
     */
    getFavoriteColumnsRefresh() {
        return this.refreshFavoriteColumns$.pipe(filter(it => it != null));
    }
    /**
     * Demande le rafraîchissement des personnes.
     */
    refreshPersonnes() {
        this.refreshPersonnes$.next(true);
    }
    /**
     * Indique chaque fois qu'un rafraîchissement des personnes est demandé.
     */
    getPersonnesRefresh() {
        return this.refreshPersonnes$.pipe(filter(it => it != null));
    }
}
BimElementStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BimElementStore_Factory() { return new BimElementStore(); }, token: BimElementStore, providedIn: "root" });
